import React, {Component} from 'react';
import { FieldGroups } from "../FieldGroups";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {FieldGroup} from "../FieldGroup";
import {addSubField} from "../../../../../store/actions/subFields";
import connect from "react-redux/es/connect/connect";
import ParametersNotice from "../../Parameters/ParametersNotice";
import CustomTableNotice from '../../CustomTableNotice';
import {addNewParameterFilled} from "../../../../../store/actions/parameters";
import {isParametersValid} from "../../../ClassicFunctions";
import {endpointFieldChange} from "../../../../../store/actions/endpoints";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import Pagination from "./Pagination";

class OffsetLimit extends Component {
	render() {

		const { settings, premium, parameters, addNewParameterFilled, endpointFieldChange } = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					( ( action === 'displayCustomTable' ||
						action === 'createCustomTable' ||
						action === 'editCustomTable' ||
						action === 'deleteCustomTable' ) && endpoint[action][currentItem].tableSelection[0].fields[0].value === '') ?
						<CustomTableNotice/> :

					<React.Fragment>
						<h3>Limit & Offset</h3>
						<p>Use this section for limiting (Limit) the number of items you want to display and for skipping (Offset) items.</p>
            <p>This section is very useful also in case you want to add pagination to your endpoint.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<FieldGroup label="Offset" fields={settings.endpoints[endpointId].displayData[0].offset[0].fields} group="offset" groupId={0} currentItem={currentItem} action={action}/>

            { typeof settings.endpoints[endpointId].displayData[0].pagination !== 'undefined'
              ? <Pagination parameters={endpoint.parameters} />
              : ''
            }


            <FieldGroup label="Items Per Page" fields={settings.endpoints[endpointId].displayData[0].limit[0].fields} group="limit" groupId={0} currentItem={currentItem} action={action}/>

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
  addNewParameterFilled: ( endpointId, name ) => dispatch( addNewParameterFilled( endpointId, name ) ),
  endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(OffsetLimit);
